// ===================================================
// ФАЙЛ: frontend/src/pages/Error/UnauthorizedPage.jsx
// ===================================================
import React from 'react';
import MonumentErrorLayout from '../../components/Error/MonumentErrorLayout';

const UnauthorizedPage = () => {
  return (
    <MonumentErrorLayout
      status="401"
      title="Нужен вход"
      description="Без входа в кибердеревню дальше не пускают — зайдите под своим аккаунтом."
      actionText="Войти"
      actionLink="/login"
      bgImageName="401"
    />
  );
};

export default UnauthorizedPage;
